import React from "react";
import { graphql } from "gatsby";

import CardWrapper from "../components/layout/wrapper";
import Layout from '../components/layout/layout';
import PaginationNav from "../components/post/pagination-nav";
import CategoryNavigation from "../components/post/category-nav";
import PostContent from "../components/post/content";
import Hero from "../components/hero/hero";
import Section from "../components/section/section";
import Seo from "../components/seo/seo";
import SignUp from '../components/sign-up/sign-up';
import Wrapper from "../components/wrapper/wrapper";

const Blog = ({ data, pageContext, location }) => {
  
  const { services, featuredPosts, allWpPost, serviceList, heroServiceContext, wpPage } = data;
  const serviceUrls = services?.nodes;
  const postsArray = allWpPost?.edges;
  const featuredPostsArray = featuredPosts?.edges;
  const serviceListArray = serviceList?.nodes;
  const heroServiceContextArray = heroServiceContext?.nodes;

  const { currentPage, categorySlug, numberOfPages } = pageContext;
  const currentService = categorySlug[0];

  return (
    <Layout location={ location }>
      <Wrapper>
        { heroServiceContextArray.length === 1 ?
          <Hero
            content={ [heroServiceContextArray[0]?.title] }
            ctaButtonText={ "Chat to an expert" }
            subHeader={ heroServiceContextArray[0]?.services_fields_information?.fieldServicesFieldsInformationIntro }
            type={ "secondary" }
          />
        :
          <Hero
            heroSettings = { wpPage?.hero_settings }
          />
        }
        <Section 
          heading={wpPage?.blogs_fields?.blogsIntroTitle}
          content={wpPage?.blogs_fields?.blogsIntro}
          reversed={ false }
          divId="our-blog"
        />
        <CategoryNavigation
            type = { "blog" }
            contentButtonData={ serviceListArray }
            active={ currentService }
        />
        <CardWrapper display={ postsArray && typeof postsArray !== "undefined" && postsArray.length > 0 }>
          <PostContent 
            categoriesData={ serviceUrls }
            postsData={ postsArray }
            type={ "blog" }
            active={ currentService }
            currentPage={ currentPage }
            featuredPosts={ featuredPostsArray }
            servicesData = { serviceListArray }
            showCategories = { true }
          />
          <PaginationNav 
            currentPage={ currentPage }
            pageCount={ numberOfPages }
            categorySlug={ categorySlug }
            urlSlug = { "/blog" }
          />
        </CardWrapper>
      </Wrapper>
      <SignUp />
    </Layout>
  );
}

export default Blog;

export const Head = ({ location, params, data, pageContext }) => {
  const { wpPage } = data;
  const { seo } = wpPage;

  return <Seo seo={seo} pageContext={pageContext} location={location} />
};
  
export const pageQuery = graphql`query ($id: String!, $limit: Int!, $skip: Int!, $categoryWordpressId: [Int]!, $categorySlug: [String]!, $categories: [Int]!, $featuredIds:
  [String]!) {
    wpPage(id: {eq: $id}) {
      title
      content
      seo {
        fullHead
        title
      }
      ...heroBlockFields
      blogs_fields {
        blogsIntroTitle
        blogsIntro
      }
    }
    heroServiceContext: allWpService(filter: {slug: {in: $categorySlug}}) {
      nodes {
        title
        services_fields_information {
          fieldServicesFieldsInformationIntro
        }
      }
    }
    services: allWpServiceTaxonomy(filter: {databaseId: {in: $categories}}) {
      nodes {
        id
        databaseId
        link
        name
        slug
      }
    }
    allWpPost(
      sort: {date: DESC}
      limit: $limit
      skip: $skip
      filter: {servicesTaxonomy: {nodes: {elemMatch: {databaseId: {in: $categoryWordpressId}}}}}
    ) {
      edges {
        node {
          id
          title
          date
          excerpt
          link
          primaryService
          primaryServiceTitle
          categories {
            nodes {
              name
              slug
            }
          }
          servicesTaxonomy {
            nodes {
              databaseId
              id
              name
              slug
            }
          }
          author {
            node {
              name
              slug
              id
              description
              url
              avatar {
                url
              }
            }
          }
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
                }
              }
            }
          }
        }
      }
    }
    featuredPosts: allWpPost(
      sort: {date: DESC}
      limit: 4
      filter: {id: {in: $featuredIds}}
    ) {
      edges {
        node {
          id
          title
          date
          excerpt
          link
          categories {
            nodes {
              name
              slug
            }
          }
          primaryService
          primaryServiceTitle
          servicesTaxonomy {
            nodes {
              databaseId
              id
              name
              slug
            }
          }
          author {
            node {
              name
              slug
              id
              description
              url
              avatar {
                url
              }
            }
          }
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
                }
              }
            }
          }
        }
      }
      nodes {
        author {
          node {
            name
            slug
            id
            description
            url
            avatar {
              url
            }
          }
        }
      }
    }
    serviceList: allWpService(sort: {menuOrder: ASC}, filter: {slug: {nin: ["sales-and-marketing", "senior-leadership"]}}) {
      nodes {
        id
        title
        databaseId
        date
        slug
      }
    }
  }
`;